import React from "react";
import { Card, CardContent } from "./ui/card";
import { Calendar, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

const NewsSection = () => {
  const news = [
    {
      date: "15 Octobre 2025",
      title: "UM Groupe reconnu parmi les leaders de l'innovation énergétique",
      image:
        "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVsc3xlbnwwfHx8fDE3NjEwNjg0NTB8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      date: "2 Septembre 2025",
      title: "Lancement de notre nouvelle gamme de climatisation intelligente",
      image:
        "https://images.unsplash.com/photo-1615309662243-70f6df917b59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxodmFjfGVufDB8fHx8MTc2MTA2ODQ1Nnww&ixlib=rb-4.1.0&q=85",
    },
    {
      date: "21 Août 2025",
      title: "Partenariat stratégique pour déploiement fibre optique national",
      image:
        "https://images.unsplash.com/photo-1604869515882-4d10fa4b0492?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxmaWJlciUyMG9wdGljfGVufDB8fHx8MTc2MTA2ODQ3MXww&ixlib=rb-4.1.0&q=85",
    },
    {
      date: "7 Août 2025",
      title: "Rapport: 5000+ installations photovoltaïques réussies en France",
      image:
        "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxzb2xhciUyMHBhbmVsc3xlbnwwfHx8fDE3NjEwNjg0NTB8MA&ixlib=rb-4.1.0&q=85",
    },
  ];

  return (
    <section id="actualites" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">Actualités</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {news.map((item, index) => (
            <Card
              key={index}
              className="group hover:shadow-2xl transition-all duration-300 overflow-hidden border-0 cursor-pointer"
            >
              <CardContent className="p-0">
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                </div>
                <div className="p-6">
                  <div className="flex items-center space-x-2 text-sm text-gray-500 mb-3">
                    <Calendar size={16} />
                    <span>{item.date}</span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-4 leading-tight group-hover:text-blue-600 transition-colors">
                    {item.title}
                  </h3>
                  <Button
                    variant="link"
                    className="p-0 h-auto text-blue-600 hover:text-blue-700 group/btn"
                  >
                    Lire plus
                    <ArrowRight
                      className="ml-1 group-hover/btn:translate-x-1 transition-transform"
                      size={16}
                    />
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;